<app-title icon="product_thin" text="Živila" [sidebar]="true">
  <app-toggle-help>
    Baza živil je osnova za sestavljanje receptov in jedilnikov ter temelji na javnem naročilu zavoda. Živila lahko dodate: z uvozom živil na podlagi črtnih kod (priporočeno) ali uvozom referenčnih živil iz baze. Po uvozu živila preglejte in dopolnite. Omogočeno je tudi individualno dodajanje živil (ročni vnos). Dodatna navodila najdete v video predstavitvi v spletni učilnici Šolski lonec.
  </app-toggle-help>
</app-title>

<app-main-with-aside>
  <ng-container aside>
    <div class="add-buttons">
      <button class="btn-add-horizontal-large" (click)="importOpened = true">
        <span>Uvozi živila<br>iz baze</span>
      </button>
      <button class="btn-add-horizontal-large2" [routerLink]="['/products', 'new']">
        <span>Ročno vnesi<br>živilo</span>
      </button>
    </div>

    <app-product-list *ngIf="!type || type === 'new'" [l3FoodGroups]="l3FoodGroups" [selected]="productId" (pick)="showProduct($event)" (delete)="deleteProduct($event)" [includeIncomplete]="true"></app-product-list>
  </ng-container>
  <ng-container main>
    <app-error></app-error>
    <app-product-form *ngIf="type === 'new' || values" (save)="save($event)" [values]="values" (dirty)="setDirty($event)">
      <button *ngIf="values && !type" class="btn-copy" (click)="copy()" type="button">Kopiraj</button>
      <button *ngIf="productId && type!=='new'" class="btn-cancel" type="button" (click)="remove()">Izbriši</button>
      <app-submit-button #submit></app-submit-button>
    </app-product-form>
    <app-import-product *ngIf="importOpened" [yearId]="yearId" (done)="importOpened = false"></app-import-product>
    <div id="aside-marker"></div>
  </ng-container>
</app-main-with-aside>

